import { Factory } from '../../shared/factory';
import { Injectable } from '@angular/core';
import { User } from '../../shared/models/user';

@Injectable({
    providedIn: 'root',
})
export class UsersFactory extends Factory<User> {
    constructor() {
        super(User);
    }

}
